import {Annotation} from '@codemirror/state';

export const skipOnChange = Annotation.define<boolean>();

/**
 * When attached to a transaction, causes the debounced onChange callback to flush immediately
 * instead of waiting for the debounce timer. Use for discrete user actions (widget removal,
 * dropdown selection) that must persist before the editor can be disposed.
 */
export const flushOnChange = Annotation.define<boolean>();
